<template>
  <div class="filters-section">
    <div class="filter-group">
      <div class="filter-title">
        <b-icon icon="geo-alt"></b-icon>
        {{ $t('sidebar.stores') }}
        <span class="filter-actions">
          <a href="#" @click.prevent="selectAll">{{ $t('sidebar.all') }}</a>
          <span class="separator">/</span>
          <a href="#" @click.prevent="selectNone">{{ $t('sidebar.none') }}</a>
        </span>
      </div>
      <div class="filter-options">
        <label
          v-for="place in places"
          :key="place.code"
          class="filter-option"
          :class="{ 'is-checked': isSelected(place) }"
        >
          <input
            type="checkbox"
            :checked="isSelected(place)"
            @change="togglePlace(place)"
          />
          <span>{{ place.label }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StoreFilter',

  computed: {
    places() {
      return this.$store.state.places
    },
    selectedPlaces() {
      return this.$store.state.selectedPlaces
    }
  },

  methods: {
    isSelected(place) {
      return this.selectedPlaces.some(p => p.code === place.code)
    },

    togglePlace(place) {
      this.$store.dispatch('toggleSelectedPlace', place)
      this.$emit('filter-changed')
    },

    selectAll() {
      this.$store.dispatch('setSelectedPlaces', [...this.places])
      this.$emit('filter-changed')
    },

    selectNone() {
      this.$store.dispatch('setSelectedPlaces', [])
      this.$emit('filter-changed')
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-actions {
  margin-left: auto;
  font-size: 0.8rem;
  font-weight: 400;
  text-transform: none;

  a {
    color: #1A1A1A;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .separator {
    margin: 0 0.25rem;
    color: #999;
  }
}
</style>
